import * as deepObject from 'deep-object-diff'
import TableHelper from '../../TableHelper'
import { PermissionResult } from '../../../helpers/permission-checker.helper'
import { hasUrlFilters } from '../../../helpers/filter.helper'

type ActionRefsType = {
  edit: Array<any>,
  delete: Array<any>
}

export type ListComponentProps = {
  permissions?: PermissionResult,

  loading: boolean,
  history: any
}

export default class ListComponent<T> extends TableHelper<T> {

  actionRefs: ActionRefsType = {
    edit: [],
    delete: []
  }

  protected load() {}

  componentDidMount() {
    // When the URL carries filters, the shared <Filters> component normally drives
    // the (filtered) load, so a freshly mounted list skips its own load to avoid an
    // initial unfiltered fetch. But navigating between tabs that share the same
    // filter value (e.g. the Pending Mappings cards, all `?filter_active=false`)
    // doesn't change the filter, so <Filters> never re-dispatches — and the new
    // list would otherwise never load (the "stalled after first load" bug). If the
    // resolved filters are already in props, load now; otherwise let <Filters>
    // drive the first load once it resolves them.
    if (!hasUrlFilters() || (this.props as any).filters) {
      this.load()
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { searchOptions }: any = this.props

    // Validate permissions
    this.validateAccessPermissions()

    if (searchOptions?.search) {
      // Check if our search has changed and sync with our table helper
      const isDiff = Object.keys(deepObject.diff(this.searchOptions.search, searchOptions.search)).length > 0
      if (isDiff) {
        this.searchOptions.search = searchOptions.search
      }
    }
  }

  validateAccessPermissions = () => {
    const { permissions: listPermissions }: any = this.props

    if (listPermissions) {
      const permissions = listPermissions as PermissionResult

      if (!permissions.save) {
        this.actionRefs.edit.forEach(ref => {
          if (ref) {
            ref.style.display = !permissions.save ? 'none' : ''
          }
        })
      }
      if (!permissions.delete) {
        this.actionRefs.delete.forEach(ref => {
          if (ref) {
            ref.style.display = !permissions.delete ? 'none' : ''
          }
        })
      }
    }
  }
}
